import { GetServerSidePropsContext } from 'next';
import { ParsedUrlQuery } from 'querystring';
import { UiLoader } from 'znanie-uikit';
import initializeApollo, { addApolloState } from 'apollo-client';

import LayoutConfines from 'components/layout/LayoutConfines';
import SinglePost from 'components/post/SinglePost';
import PageMeta, { defaultMeta } from 'components/layout/PageMeta';

import NotFound from 'pages/404';

import { usePost, getPostSsr } from 'hooks/post/usePost';
import { PostType } from 'graphql/types';

interface IParams extends ParsedUrlQuery {
  slug: string;
}

interface IProps {
  slug: string;
}

export default function Post({ slug }: IProps) {
  const { data: postData, loading: postLoading } = usePost(slug);
  const post = postData?.postBySlug as PostType;

  if (!post) {
    return <NotFound />;
  }

  return (
    <>
      <PageMeta
        title={`${post?.title} - Российское Общество «Знание»` || ''}
        description={post?.description || ''}
        image={post?.imageUrl || ''}
        canonicalHref={`${defaultMeta.canonicalHref}/news/${post?.slug}`}
      />
      <UiLoader loading={postLoading}>
        <LayoutConfines>
          <SinglePost post={post} />
        </LayoutConfines>
      </UiLoader>
    </>
  );
}

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
  const apolloClient = initializeApollo();
  const { slug } = ctx.params as IParams;

  await getPostSsr(apolloClient, slug);

  return addApolloState(apolloClient, {
    props: {
      slug,
    },
  });
}
